module.exports = __webpack_public_path__ + "img/mon_64.8c262bfd.png";